import { type ValidatorRule } from "rc-field-form/lib/interface"

const validateNumber: ValidatorRule["validator"] = (rule, value) => {
  if (value === undefined || value === null || value === "") {
    return Promise.resolve()
  }

  const numStr = String(value)

  if (!numStr?.trim() && !rule?.required) {
    return Promise.resolve()
  }

  const [integerPart, decimalPart = ""] = numStr.split(".")

  // Remove minus sign for length check
  const integerDigits = integerPart.replace("-", "")

  if (integerDigits.length > 8) {
    return Promise.reject(new Error("Maximum 8 digits before decimal point"))
  }

  if (decimalPart.length > 2) {
    return Promise.reject(new Error("Maximum 2 digits after decimal point"))
  }

  const totalDigits = integerDigits.length + decimalPart.length
  if (totalDigits > 10) {
    return Promise.reject(new Error("Maximum 10 digits in total"))
  }

  return Promise.resolve()
}

const validatePositiveNumber: ValidatorRule["validator"] = async (
  rule,
  value,
  callback
) => {
  await validateNumber(rule, value, callback)

  if (value === undefined || value === null || value === "") return

  if (!(Number(value) > 0)) {
    throw new Error("Must be greater than 0")
  }
}

export { validateNumber, validatePositiveNumber }
